"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LinkBrokenLined = function LinkBrokenLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.879 17.136a.5.5 0 010 .707l-2.007 2A3.99 3.99 0 015.046 21a4.056 4.056 0 01-2.87-1.185 3.984 3.984 0 010-5.652l4.012-4a4.027 4.027 0 015.67 0A3.951 3.951 0 0113 12.443a.5.5 0 01-.99.138 2.964 2.964 0 00-.853-1.7 3.024 3.024 0 00-4.26 0l-4.016 3.991a2.984 2.984 0 000 4.234 3.042 3.042 0 004.284.026l2.007-2a.5.5 0 01.707.004zM22.46 9.054a4.066 4.066 0 00-2.491-1.916 3.966 3.966 0 00-3.031.394l-2.685 1.533a.5.5 0 10.5.868L17.437 8.4a2.972 2.972 0 012.273-.3 3.077 3.077 0 01.778 5.621l-4.939 2.869a3.02 3.02 0 01-4.139-1.122 3.057 3.057 0 01-.387-1.9.5.5 0 00-.992-.122A4.055 4.055 0 0014.045 18a3.981 3.981 0 002.006-.544l4.939-2.866a4.069 4.069 0 001.47-5.536zM10.508 7a.5.5 0 00.5-.5v-3a.5.5 0 00-1 0v3a.5.5 0 00.5.5zm-3.384-.147a.5.5 0 00.707 0 .5.5 0 000-.707l-2-2a.5.5 0 10-.708.707zM13.478 7a.494.494 0 00.353-.146l2-2a.5.5 0 00-.707-.707l-2 2a.5.5 0 00.354.853z",
    fill: "currentColor"
  })));
};

var _default = LinkBrokenLined;
exports["default"] = _default;